module.exports = __webpack_public_path__ + "img/des-bras-en-plus-logo.png";